import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { ValidationSummary } from "devextreme-react/validation-summary";
import {
	ActualDeliveryDatePanel,
	ExitButton,
	PurchaseOrderAddNoteButton,
	PurchaseOrderCards,
	PurchaseOrderDeliveryProducts,
	PurchaseOrderFilesButton,
	PurchaseOrderNotesPanel,
	PurchaseOrderPage,
	PurchaseOrderProgress,
	PurchaseOrderProgressStep,
	SaveButton
} from '../../../features/distributor/purchase-order';
import '../../../css/order.scss';

export default function PurchaseOrderDeliveryDetailsPage() {

	return (

		<PurchaseOrderPage>

			<PurchaseOrderCards />

			<PurchaseOrderProgress />

			<ValidationSummary />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<SaveButton step={PurchaseOrderProgressStep.DeliveryDetails} />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PurchaseOrderFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<PurchaseOrderAddNoteButton />
				</ToolbarItem>
			</Toolbar>

			<Box>
				<Item ratio={1}>
					<ActualDeliveryDatePanel />
				</Item>
				<Item ratio={1}>
					<PurchaseOrderNotesPanel height={200} />
				</Item>
			</Box>

			<PurchaseOrderDeliveryProducts />

		</PurchaseOrderPage>
	)
}
